// Copyright (c) 2016 Deere & Company

import './new-status-info.scss';
import React, {PropTypes} from 'react';
import Comments from './input-fields/comments';
import DamageDateDetails from './damage-date';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import FileAttachmentPanel from '../../../shared/components/file-attachment-panel';
import {FormattedMessage} from 'react-intl';
import InlineAlertBar from '../../../shared/components/inline-alert-bar';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import NewStatusDropdown from './dropdowns/new-status-dropdown';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import RadioButtonList from '../../../shared/components/radio-button-list/radio-button-list';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import StatusChangeDetails from './status-change-details';
import showFileUploadStatuses from '../utils/show-file-upload-statuses';

function handleFileUpload(file, dropzone) {

    this.handleFileUploadSuccess(JSON.parse(file.xhr.response));
    dropzone.removeFile(file);

}

const radioButtonItems = new KeyValuePairCollection([

    {
        key: 'N',
        value: 'NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE'
    }, {
        key: 'Y',
        value: 'YES_LOWERCASE'
    }
]);

function handleSelectedContributionChange(radioIndex) {

    this.onSelectedMachinePutBack(radioButtonItems[radioIndex]);

}

function showAsteriskSymbolOnAttachments(statusChangeRequest) {

    if ((statusChangeRequest.newStatus.key === 'STLP') || ((statusChangeRequest.newStatus.key === 'DMGD' || statusChangeRequest.newStatus.key === 'EOOS') && statusChangeRequest.machinePutBack === 'Y')) {

        return false;

    }
    return true;

}
const NewStatusInfo = props => {

    const serviceConfig = {
        className: 'EQUI',
        classType: 'BO',
        objectKey: props.product.pin
    };

    const isStatusOfTypeDamagedEoss = props.statusChangeRequest.newStatus.key === 'DMGD' || props.statusChangeRequest.newStatus.key === 'EOOS';

    const buildInfoMessage = statusKey => {

        const mapper = {
            DMGD: 'DAMAGED_MACHINES_HELP_TEXT',
            EOOS: 'PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT'
        };

        return mapper[statusKey];

    };

    return (
        <div>
            <section className='new-status-info'>
                <div className='status-change-criteria'>
                    <span className='required-label'>
                        <sup>{'*'}</sup> <FormattedMessage id='INDICATES_REQUIRED_FIELD'/>
                    </span>
                    <NewStatusDropdown
                        disabled={props.isMatchineStatusChange}
                        newStatus={props.statusChangeRequest.newStatus ? props.statusChangeRequest.newStatus : null}
                        onItemChange={props.onItemChange}
                        statuses={props.statuses}
                    />
                    {isStatusOfTypeDamagedEoss ?
                        <div className='status-change-damaged-eoos'>
                            <InlineAlertBar
                                label={buildInfoMessage(props.statusChangeRequest.newStatus.key)}
                                type='info'
                            />
                            <Comments
                                charLimit={'500'}
                                isRequired={true}
                                label={'DESCRIPTION_OF_DAMAGE'}
                                name={'damageDesc'}
                                onItemChange={props.onItemChange}
                                value={props.statusChangeRequest.damageDesc}
                            />
                            <Comments
                                charLimit={'500'}
                                isRequired={true}
                                label={'DESCRIPTION_OF_EVENT_CAUSING_DAMAGE'}
                                name={'damageEventDesc'}
                                onItemChange={props.onItemChange}
                                value={props.statusChangeRequest.damageEventDesc}
                            />
                            <DamageDateDetails
                                onItemChange={props.onItemChange}
                                statusChangeRequest={props.statusChangeRequest}
                            />
                            <span className='data-label'>
                                <FormattedMessage id={'CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE'}/>
                            </span>
                            <RadioButtonList
                                items={radioButtonItems}
                                onItemsUpdate={props::handleSelectedContributionChange}
                                selectedKey={props.statusChangeRequest.machinePutBack}
                            />
                        </div> :
                        <Comments
                            charLimit={'239'}
                            isRequired={true}
                            label={'COMMENTS'}
                            name={'comments'}
                            onItemChange={props.onItemChange}
                            value={props.statusChangeRequest.comments}
                        />

                    }
                </div>
                <div className='status-change-details'>
                    <StatusChangeDetails
                        countries={props.countries}
                        onItemChange={props.onItemChange}
                        statesInCountry={props.statesInCountry}
                        statusChangeRequest={props.statusChangeRequest}
                    />
                </div>
            </section>
            {showFileUploadStatuses.includes(props.statusChangeRequest.newStatus.key) &&
                <section className='new-status-info'>
                    <div className='file-upload'>
                        <FileAttachmentPanel
                            files={props.files}
                            isRequired={showAsteriskSymbolOnAttachments((props.statusChangeRequest))}
                            onFileDelete={props.handleFileDelete}
                            onFileUploadSuccess={props::handleFileUpload}
                            serviceConfig={serviceConfig}
                        />
                    </div>
                </section>
            }
        </div>
    );

};

NewStatusInfo.displayName = 'NewStatusInfo';
NewStatusInfo.propTypes = {
    countries: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    files: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
    handleFileDelete: PropTypes.func.isRequired,
    handleFileUploadSuccess: PropTypes.func.isRequired,
    isMatchineStatusChange: PropTypes.bool.isRequired,
    onItemChange: PropTypes.func.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    statesInCountry: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired,
    statuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};
Comments.defaultProps = {
    isRequired: false
};

export default NewStatusInfo;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/new-status-info.js